import React from "react";
import type { LinkProps } from "@jasperlabs/ui";

import { useActiveTenant } from "@/tenants/TenantProvider";
import SanityUrlOrFileLink from "./SanityUrlOrFileLink";

export function TenantTermsAndConditionsLink({
	children = "Terms & Conditions",
	...props
}: Omit<LinkProps<"a">, "href" | "children"> & { children?: React.ReactNode }) {
	const tenant = useActiveTenant();

	return (
		<SanityUrlOrFileLink
			urlOrFile={
				tenant.termsAndConditions ?? { type: "url", url: null, fileUrl: null }
			}
			{...props}
		>
			{children}
		</SanityUrlOrFileLink>
	);
}
